/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable import/prefer-default-export */
import {
    // unitBase,
    rowSpacing,
    fontSizeDesktop,
    // fontSize,
    enterpriseCSS,
    paletteHD,
} from './variables';

export const DesktopChangePasswordStyle = (typography, palette) => {
    const newPalette = !palette || !palette.cta1 ? paletteHD : palette;

    return {
        DesktopChangePasswordStyle: {
            maxWidth: newPalette.myAccount.container.maxWidth.upLarge,
            margin: '0 auto',
            marginBottom: rowSpacing * 2,

            '& .passwordFields': {
                position: 'relative',
            },

            '& .description': {
                margin: '0 !important',
            },

            '& .changePasswordSuccess': {
                fontWeight: 700,
            },
            '& .contReqInfo': {
                marginTop: '12px',
                minWidth: '320px',
            },
            '& .passwordRequirementInfo': {
                fontSize: fontSizeDesktop.small,
                color: `${enterpriseCSS.palette.gray1} !important`,
                width: '100%',
            },
        },
    };
};
